<!-- 予約/購入エラー -->
<template>
  <TemplateMfittBookingTimeoutPage />
</template>

<script>
import TemplateMfittBookingTimeoutPage from "@/views/Templates/MFITT/TemplateMfittBookingTimeoutPage";

import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";

export default {
  name: "MfittBookingTimeoutPage",
  components: {
    TemplateMfittBookingTimeoutPage,
  },
  setup() {},
};
</script>
